import { render, staticRenderFns } from "./main-header-navigation.vue?vue&type=template&id=32628149&scoped=true&"
import script from "./main-header-navigation.vue?vue&type=script&lang=js&"
export * from "./main-header-navigation.vue?vue&type=script&lang=js&"
import style0 from "./main-header-navigation.vue?vue&type=style&index=0&id=32628149&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "32628149",
  null
  
)

export default component.exports